import type { ClubProcessedBenefit } from '@/utils/clubMonthlySummary';

const getServiceHintFromBenefit = (benefit: ClubProcessedBenefit) => {
	const searchableText = `${benefit.title || ''} ${
		benefit.description || ''
	}`.toLowerCase();

	if (searchableText.includes('psicolog')) return 'psychologist';
	if (
		searchableText.includes('psiquiat') ||
		searchableText.includes('médic')
	) {
		return 'psychiatrist';
	}

	return null;
};

export const buildClubBenefitConsultaPath = (
	benefit: ClubProcessedBenefit,
): string => {
	const hint = getServiceHintFromBenefit(benefit);
	const serviceId = benefit.serviceId;
	const params = new URLSearchParams();
	params.set('from', 'benefit');
	if (hint) params.set('service', hint);
	if (serviceId) params.set('service_id', serviceId);
	const query = params.toString() ? `?${params.toString()}` : '';
	return `/consulta${query}`;
};
